import { IconButton as Mui4IconButton, IconButtonProps as Mui4IconButtonPropsType } from '@material-ui/core'
import { default as Mui5IconButton, IconButtonProps as Mui5IconButtonPropsType } from '@mui/material/IconButton'
import React, { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsIconButtonVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type IconButtonProps = Omit<Mui5IconButtonPropsType, 'color'> & {
  color?: Mui4IconButtonPropsType['color'] | Mui5IconButtonPropsType['color']
  shape?: Mui5IconButtonPropsType['shape']
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  let version = useComponentVersion('icon_button')
  let { color, shape, size, variant, ...rest } = props

  switch (version) {
    case OsIconButtonVersion.V2:
      let color5: Mui5IconButtonPropsType['color'] = color === 'default' ? undefined : color
      let className = rest.className || ''
      return (
        <Mui5IconButton
          size={size || 'xSmall'}
          ref={ref}
          color={color5}
          shape={shape}
          variant={variant}
          {...rest}
          className={className}
          disableRipple
        ></Mui5IconButton>
      )

    default:
      let color4: Mui4IconButtonPropsType['color'] =
        color === 'inherit' || color === 'primary' || color === 'secondary' || color === 'default' ? color : 'default'
      return (
        <Mui4IconButton
          ref={ref}
          size={size === 'xSmall' || size === 'xXSmall' ? 'small' : 'medium'}
          color={color4}
          {...rest}
        ></Mui4IconButton>
      )
  }
})

// extend the spec
declare module '@mui/material/IconButton' {
  interface IconButtonOwnProps {
    shape?: 'squared' | 'rounded'
  }

  interface IconButtonPropsColorOverrides {
    tertiary: true
  }
  interface IconButtonPropsSizeOverrides {
    xSmall: true
    xXSmall: true
  }

  interface IconButtonOwnProps {
    variant?: 'contained' | 'outlined' | 'text'
  }
}
